<template>
  <v-dialog :model-value="!!items.length" max-width="1100" scrollable @update:model-value="$emit('close')">
    <v-card v-if="items.length">
      <v-toolbar :color="levelColor(items[0].level)">
        <v-toolbar-title>{{ items[0].filename }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" @click="$emit('close')" />
      </v-toolbar>

      <v-card-text>
        <div v-if="items.length > 1" class="text-medium-emphasis mb-3">
          {{ items.length }} варианта сообщения для этой строки кода
        </div>

        <v-expansion-panels v-model="openPanel" variant="accordion">
          <v-expansion-panel v-for="(context, index) in items" :key="context.id">
            <v-expansion-panel-title>
              <v-row no-gutters align="center">
                <v-col cols="auto" class="mr-2">
                  <v-chip :color="statusColor(context.status)" size="small">
                    {{ statusLabel(context.status) }}
                  </v-chip>
                </v-col>
                <v-col class="text-truncate">{{ context.message }}</v-col>
                <v-col cols="auto" class="text-medium-emphasis text-caption ml-2">
                  {{ formatDate(context.timemodified) }}
                </v-col>
              </v-row>
            </v-expansion-panel-title>

            <v-expansion-panel-text>
              <v-row class="mb-2" dense>
                <v-col cols="12" md="4"><b>ID журнала:</b> {{ context.id }}</v-col>
                <v-col v-if="context.remoteid" cols="12" md="4">
                  <b>ID источника:</b> {{ context.remoteid }}
                </v-col>
                <v-col cols="12" md="4"><b>Сервер:</b> {{ context.origin || '—' }}</v-col>
                <v-col cols="12" md="4"><b>Повторов:</b> {{ context.occurrences }}</v-col>
                <v-col cols="12" md="6"><b>Впервые:</b> {{ formatDate(context.timecreated) }}</v-col>
                <v-col cols="12" md="6"><b>Последний раз:</b> {{ formatDate(context.timemodified) }}</v-col>
              </v-row>

              <v-divider class="my-3" />

              <div class="text-subtitle-1 mb-2">Трейс</div>
              <v-expansion-panels v-if="context.trace && context.trace.length" variant="accordion">
                <v-expansion-panel v-for="(frame, i) in context.trace" :key="i">
                  <v-expansion-panel-title>
                    {{ frame.file }}:{{ frame.line }}
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <pre v-if="frame.frame" class="trace-frame"><code><span
                        v-for="(prefix, j) in frame.frame.prefix"
                        :key="'p' + j"
                      >{{ frame.line - (frame.frame.prefix.length - j) }}.  {{ prefix }}
</span><span class="trace-current">{{ frame.line }}.  {{ frame.frame.line }}
</span><span
                        v-for="(suffix, j) in frame.frame.suffix"
                        :key="'s' + j"
                      >{{ frame.line + j + 1 }}.  {{ suffix }}
</span></code></pre>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
              <div v-else class="text-medium-emphasis">трейс недоступен</div>

              <v-divider class="my-3" />

              <div class="text-subtitle-1 mb-2">Запрос</div>
              <div><b>method:</b> {{ context.request_method }}</div>
              <div><b>uri:</b> {{ context.request_uri }}</div>
              <div><b>query_string:</b> {{ context.query_string }}</div>
              <div v-if="context.get_params && Object.keys(context.get_params).length" class="mt-2">
                <b>GET-параметры:</b>
                <pre class="trace-frame">{{ formatRequestParams(context.get_params) }}</pre>
              </div>
              <div v-if="context.post_params && Object.keys(context.post_params).length" class="mt-2">
                <b>POST-параметры:</b>
                <pre class="trace-frame">{{ formatRequestParams(context.post_params) }}</pre>
              </div>
              <div v-if="context.body"><b>body:</b> <pre class="trace-frame">{{ context.body }}</pre></div>

              <template v-if="context.headers && Object.keys(context.headers).length">
                <v-divider class="my-3" />
                <div class="text-subtitle-1 mb-2">Заголовки запроса</div>
                <div v-for="(value, name) in context.headers" :key="name">{{ name }}: {{ value }}</div>
              </template>

              <template v-if="context.cookies && Object.keys(context.cookies).length">
                <v-divider class="my-3" />
                <div class="text-subtitle-1 mb-2">Куки</div>
                <div v-for="(value, name) in context.cookies" :key="name">{{ name }}: {{ value }}</div>
              </template>

              <v-card-actions class="pl-0">
                <v-btn
                  v-if="context.status != 2"
                  color="warning"
                  size="small"
                  prepend-icon="mdi-bug-check-outline"
                  @click="$emit('set-status', { id: context.id, status: 2 })"
                >
                  Не ошибка
                </v-btn>
                <v-btn
                  v-if="context.status != 100"
                  color="success"
                  size="small"
                  prepend-icon="mdi-check-circle-outline"
                  @click="$emit('set-status', { id: context.id, status: 100 })"
                >
                  Решено
                </v-btn>
                <v-btn
                  v-if="context.status != 0"
                  size="small"
                  prepend-icon="mdi-lock-open-outline"
                  @click="$emit('set-status', { id: context.id, status: 0 })"
                >
                  Открыть
                </v-btn>
                <v-spacer />
                <v-btn
                  color="error"
                  size="small"
                  prepend-icon="mdi-delete"
                  @click="$emit('remove', context.id)"
                >
                  Удалить
                </v-btn>
              </v-card-actions>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
const STATUS_LABELS = {
  0: 'К выполнению',
  1: 'В работе',
  2: 'Не ошибка',
  20: 'Не ошибка',
  100: 'Решено',
};

export default {
  name: "ErrorDetail",
  props: {
    items: { type: Array, default: () => [] },
  },
  emits: ["close", "set-status", "remove"],
  data() {
    return {
      // Первый контекст (самый свежий — items уже отсортированы) раскрыт сразу.
      openPanel: 0,
    };
  },
  methods: {
    levelColor(level) {
      if (level === "DEBUG" || level === "INFO") return "primary";
      if (level === "NOTICE" || level === "WARNING") return "orange";
      return "red";
    },
    statusLabel(status) {
      return STATUS_LABELS[status] ?? "К выполнению";
    },
    statusColor(status) {
      if (status === 100 || status === 2 || status === 20) return "success";
      if (status === 1) return "orange";
      return "grey";
    },
    formatDate(ts) {
      return ts ? new Date(ts * 1000).toLocaleString("ru") : "—";
    },
    formatRequestParams(params) {
      const normalize = (value) => {
        if (Array.isArray(value)) {
          return value.map(normalize);
        }

        if (value && typeof value === "object") {
          return Object.fromEntries(
            Object.entries(value).map(([key, item]) => [key, normalize(item)])
          );
        }

        if (typeof value === "string") {
          const trimmed = value.trim();
          const isJsonContainer =
            (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
            (trimmed.startsWith("[") && trimmed.endsWith("]"));

          if (isJsonContainer) {
            try {
              return normalize(JSON.parse(trimmed));
            } catch (error) {
              // Не повреждаем обычную строку, лишь похожую на JSON.
            }
          }
        }

        return value;
      };

      return JSON.stringify(normalize(params), null, 2);
    },
  },
};
</script>

<style scoped>
.trace-frame {
  white-space: pre-wrap;
  word-break: break-word;
  background: rgba(128, 128, 128, 0.08);
  padding: 8px;
  border-radius: 4px;
}
.trace-current {
  display: block;
  background: rgba(255, 82, 82, 0.15);
  font-weight: bold;
}
</style>
